import React, { useState, useEffect } from 'react';
import Back from '../components/common/Back';
import BlogComments from '../components/blog/BlogComments';
import { getAllBlogs } from '../utils/api';
import img from '../components/images/bannerblog111.jpg';
import '../components/home/recent/recent.css';
import './Blog.css';

// Blog resim URL'sini düzeltmek için yardımcı fonksiyon
const getBlogImageUrl = (blog) => {
  // Eğer resim yoksa boş döndür
  if (!blog.image) return '';
  
  // Eğer zaten tam URL ise, olduğu gibi döndür
  if (blog.image.startsWith('http://') || blog.image.startsWith('https://')) {
    return blog.image;
  }
  
  // Blog resimleri için doğru URL'yi oluştur
  const baseUrl = process.env.REACT_APP_API_URL?.replace('/api', '') || 'https://mayadangayrimenkul.com.tr';
  const fullUrl = `${baseUrl}/upload/blog/${blog.image}`;
  
  return fullUrl;
};

// Resim yüklenme hatası için placeholder
const handleImageError = (event) => {
  event.target.style.display = 'none';
  const placeholder = event.target.parentNode.querySelector('.blog-placeholder-image');
  if (placeholder) {
    placeholder.style.display = 'flex';
  }
};

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedBlog, setSelectedBlog] = useState(null);


  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const data = await getAllBlogs();
      setBlogs(data);
      setLoading(false);
    } catch (error) {
      console.error('Blog yüklenirken hata:', error);
      setLoading(false);
    }
  };

  const handleBlogClick = (blog) => {
    setSelectedBlog(blog);
  };

  const handleBackToList = () => {
    setSelectedBlog(null);
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Bloglar yükleniyor...</p>
      </div>
    );
  }

  if (selectedBlog) {
    return (
      <div className="blog-detail-container">
        <div className="blog-detail-header">
          <button onClick={handleBackToList} className="back-button">
            ← Geri Dön
          </button>
        </div>
        <div className="blog-detail-content">
          <h1>{selectedBlog.title}</h1>
          <div className="blog-meta">
            <span className="blog-date">
              {new Date(selectedBlog.created_at).toLocaleDateString('tr-TR')}
            </span>
            <span className="blog-author">Yazar: {selectedBlog.author}</span>
          </div>
          <div className="blog-image">
            {selectedBlog.image && (
              <>
                <img src={getBlogImageUrl(selectedBlog)} alt={selectedBlog.title} onError={handleImageError} />
                <div className="blog-placeholder-image" style={{ display: 'none' }}>
                  <span>Resim Yok</span>
                </div>
              </>
            )}
          </div>
          <div className="blog-content">
            {selectedBlog.content}
          </div>
          
          {/* Blog Yorumları */}
          <BlogComments blogId={selectedBlog.id} />
        </div>
      </div>
    );
  }

  return (
    <>
      <section className='blog-out mb'>
        <Back name='Gayrimenkul Bilgi ve İlham Noktanız' title='Gayrimenkul Bilgi ve İlham Noktanız' cover={img} />
        <div className='container recent'>
          <div className="blog-grid">
            {blogs.map((blog) => (
              <div key={blog.id} className="blog-card" onClick={() => handleBlogClick(blog)}>
                <div className="blog-card-image">
                  {blog.image ? (
                    <>
                      <img src={getBlogImageUrl(blog)} alt={blog.title} onError={handleImageError} />
                      <div className="blog-placeholder-image" style={{ display: 'none' }}>
                        <span>Resim Yok</span>
                      </div>
                    </>
                  ) : (
                    <div className="blog-placeholder-image">
                      <span>Resim Yok</span>
                    </div>
                  )}
                </div>
                <div className="blog-card-content">
                  <h3>{blog.title}</h3>
                  <p className="blog-excerpt">
                    {blog.content.replace(/<[^>]*>/g, '').substring(0, 150)}...
                  </p>
                  <div className="blog-meta">
                    <span className="blog-date">
                      {new Date(blog.created_at).toLocaleDateString('tr-TR')}
                    </span>
                    <span className="blog-author">{blog.author}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {blogs.length === 0 && (
            <div className="no-blogs">
              <p>Henüz blog yazısı bulunmamaktadır.</p>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Blog; 